/**
 * @desc 申请箱号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierBoxBatch.applyBoxCode.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBoxBatch/applyBoxCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
